import { MaterialityTimeHorizon } from '@upright/common/model/input/materiality-assessment/types';

export function friendlyCombinedMaterialityTimeHorizon(horizons: MaterialityTimeHorizon[]) {
  const fh = horizons.filter(h => h !== MaterialityTimeHorizon.UNKNOWN);

  if (fh.length === 0) {
    return `Various`;
  } else if (fh.length === 1) {
    return `${friendlyMaterialityTimeHorizon(fh[0])}`;
  } else if (fh.length === 2) {
    if (fh.includes(MaterialityTimeHorizon.SHORT_TERM) && fh.includes(MaterialityTimeHorizon.MEDIUM_TERM)) {
      return `Short-to-medium-term`;
    }
    if (fh.includes(MaterialityTimeHorizon.SHORT_TERM) && fh.includes(MaterialityTimeHorizon.LONG_TERM)) {
      return `Short-to-long-term`;
    }
    if (fh.includes(MaterialityTimeHorizon.MEDIUM_TERM) && fh.includes(MaterialityTimeHorizon.LONG_TERM)) {
      return `Medium-to-long-term`;
    }
    throw Error(`Unexpected set of two time horizons`);
  } else if (fh.length === 3) {
    return `Short-to-long-term`;
  }
  throw Error(`Number of horizons is ${fh.length}`);
}

export function friendlyMaterialityTimeHorizon(horizon: MaterialityTimeHorizon | undefined) {
  if (!horizon) {
    return '';
  }
  switch (horizon) {
    case MaterialityTimeHorizon.LONG_TERM:
      return 'Long-term';
    case MaterialityTimeHorizon.MEDIUM_TERM:
      return 'Medium-term';
    case MaterialityTimeHorizon.SHORT_TERM:
      return 'Short-term';
    case MaterialityTimeHorizon.UNKNOWN:
      return 'Unknown';
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw Error(`Unknown time horizon: ${horizon}`);
  }
}
